/* eslint-disable */
import { t } from "i18next";
export default function validateAddressFn(response: any, addressDr?: any, onlyZipStateCountry?: boolean, request?: any) {
    const ADDRESS_NOT_FOUND_MSG =t('We were unable to locate the address provided. Please verify that the information is correct and try again.');
    const address = response.result.address;
    const confirmedComponents = ["postal_code", "locality", "administrative_area_level_1"];
    const confirmationComp = ['CONFIRMED', 'UNCONFIRMED_BUT_PLAUSIBLE'];
    
    let show_suggested = false;
    let enforce_suggested = false;

    const checkAddressModifications = () => {
        if (!address.addressComponents) return;

        let localityInferred = false;
        let administrativeAreaInferred = false;
        let postalCodeInferred = false;
        
        let localityReplaced = false;
        let administrativeAreaReplaced = false;
        let postalCodeReplaced = false;
        
        let localitySpellchecked = false;
        let administrativeAreaSpellchecked = false;
        let postalCodeSpellchecked = false;

        // Check for all types of modifications in key components
        for (const component of address.addressComponents) {
            if (component.componentType === "locality") {
                localityInferred = component.inferred || false;
                localityReplaced = component.replaced || false;
                localitySpellchecked = component.spellchecked || false;
            } else if (component.componentType === "administrative_area_level_1") {
                administrativeAreaInferred = component.inferred || false;
                administrativeAreaReplaced = component.replaced || false;
                administrativeAreaSpellchecked = component.spellchecked || false;
            } else if (component.componentType === "postal_code") {
                postalCodeInferred = component.inferred || false;
                postalCodeReplaced = component.replaced || false;
                postalCodeSpellchecked = component.spellchecked || false;
            }
        }

        // Check if any of the key components have modifications
        const hasModifications = localityInferred || administrativeAreaInferred || postalCodeInferred ||
            localityReplaced || administrativeAreaReplaced || postalCodeReplaced ||
            localitySpellchecked || administrativeAreaSpellchecked || postalCodeSpellchecked;

        // If no modifications in key components, enforce suggested address
        if (!hasModifications) {
            enforce_suggested = true;
            show_suggested = false;
            return;
        }

        // Set flags based on inferred components
        if (localityInferred && administrativeAreaInferred) {
            // Both locality and administrative_area_level_1 are inferred
            show_suggested = true;
            enforce_suggested = false;
        } else if (postalCodeInferred) {
            // Only postal_code is inferred
            enforce_suggested = true;
            show_suggested = false;
        } else if (localityInferred || administrativeAreaInferred) {
            // If either locality or administrative_area_level_1 is inferred
            show_suggested = true;
            enforce_suggested = false;
        } else {
            // For replaced or spellchecked components
            enforce_suggested = true;
            show_suggested = false;
        }
    };
    function hasConfirmedOverlap(): boolean {
    const hasMissing = Array.isArray(address.missingComponentTypes) &&
        address.missingComponentTypes.some((item: any) => confirmedComponents.includes(item));

    const hasUnconfirmed = Array.isArray(address.unconfirmedComponentTypes) &&
        address.unconfirmedComponentTypes.some((item: any) => confirmedComponents.includes(item));

    return hasMissing || hasUnconfirmed;
}

    const validatAddressComponent = () => {
        return (address.addressComponents.filter((item: any) => confirmedComponents.includes(item.componentType))).every((item: any) => {
            return confirmedComponents.includes(item.componentType) && confirmationComp.includes(item.confirmationLevel);
        });
    };
    
    const buildAddressline2 = () => {
        const street: string = request?.Addresses[0]?.StreetAddress || '';
        const addressLines = address.postalAddress.addressLines
        if ( address.postalAddress.regionCode == 'US' && street ) {
            const splitedAdd = street.split(',')
            if (splitedAdd && splitedAdd.length > 1 && addressLines.length == 1 ) {
                const secondAddressLine = response.result.uspsData.standardizedAddress?.secondAddressLine || ''
                if (secondAddressLine?.toLowerCase()?.includes(splitedAdd[1].trim()?.toLowerCase())) {
                    addressLines[1] = secondAddressLine
                    if(addressLines[0]?.toLowerCase()?.includes(splitedAdd[1].trim())){
                    const pattern = splitedAdd[1].trim()
                        addressLines[0] = addressLines[0].replace(pattern,'').trim()
                    }
                } else {
                    addressLines[1] = splitedAdd[1].trim()
                   if(addressLines[0]?.toLowerCase()?.includes(splitedAdd[1].trim()?.toLowerCase())){
                    const pattern = splitedAdd[1].trim()
                        addressLines[0] = addressLines[0].replace(pattern,'').trim()
                    }
                }
            }else if( addressLines.length == 2){
                 const standardizedAddress = response.result.uspsData.standardizedAddress || ''
                if(standardizedAddress?.secondAddressLine && standardizedAddress?.firstAddressLine){
                    addressLines[0] = standardizedAddress?.firstAddressLine;
                    addressLines[1] = standardizedAddress?.secondAddressLine;
                }else{
                const addressfields = JSON.parse(JSON.stringify(addressLines));
                addressLines[0] = addressfields[1];
                addressLines[1] = addressfields[0];
                }

            }
        }
        return addressLines
    }

    const formatgoooleAddress = () => {
        const state = address.addressComponents.filter((item: any) => {
            return item.componentType == 'administrative_area_level_1' ? true : false;
        });
        address.postalAddress.administrativeArea = state[0]?.componentName?.text ? state[0].componentName.text : request?.Addresses?.StateProvince;

        // Check for address modifications based on the new logic
        checkAddressModifications();
        address.postalAddress.addressLines = buildAddressline2();

        return {
            message: '',
            status: true,
            suggestedAddress: address.formattedAddress,
            postalAddress: address.postalAddress,
            enforce: enforce_suggested,
            requireConfirmation: show_suggested // User should confirm if components are inferred
        };
    };

    try {
        if (onlyZipStateCountry) {
            const verdict = response.result.verdict;
            if(verdict.possibleNextAction  == 'FIX'){
                return {
                    status: false,
                    message: ADDRESS_NOT_FOUND_MSG
                };
            }
            if (hasConfirmedOverlap() && !validatAddressComponent()) {
                return {
                    status: false,
                    message: ADDRESS_NOT_FOUND_MSG
                };
            } else if (!(hasConfirmedOverlap() && !validatAddressComponent()) && (addressDr?.Addresses && (addressDr.Addresses.MatchCode == '1' || addressDr.Addresses.MatchCode == '2'))) {
                const addressDoctorResponse = addressDr.Addresses;
                address.formattedAddress = addressDoctorResponse.StreetAddress;
                address.postalAddress.addressLines = [];
                if (addressDoctorResponse.Building) {
                    address.postalAddress.addressLines.push(addressDoctorResponse.Building);
                    address.formattedAddress += `, ${addressDoctorResponse.Building}`;
                }
                if (addressDoctorResponse.Unit) {
                    address.postalAddress.addressLines.push(addressDoctorResponse.Unit);
                    address.formattedAddress += `, ${addressDoctorResponse.Unit}`;
                }
                address.postalAddress.addressLines.push(addressDoctorResponse.StreetAddress);
                address.formattedAddress += `, ${addressDoctorResponse.City}, ${addressDoctorResponse.StateProvince}, ${address.postalAddress.postalCode}`;

                // Check for address modifications
                checkAddressModifications();
                address.postalAddress.addressLines = buildAddressline2();

                return {
                    message: '',
                    status: true,
                    matchCode: addressDr.Addresses.MatchCode,
                    suggestedAddress: address.formattedAddress,
                    postalAddress: address.postalAddress,
                    enforce: enforce_suggested,
                    requireConfirmation: show_suggested
                };
            } else if (!addressDr && !(hasConfirmedOverlap() && !validatAddressComponent())) {
                return formatgoooleAddress();
            } else {
                const addressDoctorResponse = addressDr.Addresses;
                address.formattedAddress = addressDoctorResponse.StreetAddress;
                address.postalAddress.addressLines = [];
                if (addressDoctorResponse.Building) {
                    address.postalAddress.addressLines.push(addressDoctorResponse.Building);
                    address.formattedAddress += `, ${addressDoctorResponse.Building}`;
                }
                if (addressDoctorResponse.Unit) {
                    address.postalAddress.addressLines.push(addressDoctorResponse.Unit);
                    address.formattedAddress += `, ${addressDoctorResponse.Unit}`;
                }
                address.postalAddress.addressLines.push(addressDoctorResponse.StreetAddress);
                address.formattedAddress += `, ${addressDoctorResponse.City}, ${addressDoctorResponse.StateProvince}, ${address.postalAddress.postalCode}`;

                // Check for address modifications
                checkAddressModifications();
                address.postalAddress.addressLines = buildAddressline2();

                return {
                    status: true,
                    suggestedAddress: address.formattedAddress,
                    postalAddress: address.postalAddress,
                    enforce: enforce_suggested,
                    requireConfirmation: show_suggested
                };
            }
        } else {
            if (!(hasConfirmedOverlap() && !validatAddressComponent())) {
                return formatgoooleAddress();
            } else {
                return {
                    status: false,
                    message: ADDRESS_NOT_FOUND_MSG
                };
            }
        }
    } catch (e: any) {
        console.error('Error occurred in the validate Address fn', e);
        return {
            status: false,
            message: t('Address validation currently Unavailable.')
        };
    }
}
